<!-- Modal that serves as a landing point for feature manipulation. There are tabs that are imported into this modal where the user searches for promotions/non promotion items, adds them to the feature
modifies the feature, etc. -->
<template>
  <v-dialog :value="value" persistent :width="isExistingFeature ? '1800' : '850'">
    <v-card class="fill">
      <v-toolbar flat class="fill">
      <v-breadcrumbs :items="breadcrumbs">
          <template #item="{ item }">
            <v-breadcrumbs-item  :style="!item.disabled ? 'cursor:pointer' : ''" :disabled="item.disabled" @click='$emit("update:value",false)'>
              <span :class="!item.disabled ? 'primary--text' : ''">{{item.text}}</span>
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
        <v-spacer/>
         <v-menu v-if="isExistingFeature" offset-y offset-x left bottom :nudge-right="5" :nudge-top="5">
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip top>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn :disabled="readonly" v-bind="attrs" v-on="{ ...tooltip, ...menu }" icon
                  color="delete" class="white--text">
                  <v-icon>mdi-trash-can</v-icon>
                </v-btn>
              </template>
              <span>{{ hasAdLayout ? 'Clear' : 'Delete' }}</span>
            </v-tooltip>
          </template>
          <v-card class="pa-6">
            <v-row justify="center" class="py-4">
              <span>{{ hasAdLayout ? 'Clear' : 'Delete' }} Feature?</span>
            </v-row>
            <v-row>
              <v-btn text :class="body">Cancel</v-btn>
              <v-btn :class="body" class="primary white--text ml-2" @click="deleteAdFeature">
                Confirm
              </v-btn>
            </v-row>
          </v-card>
        </v-menu>
          <v-btn icon  @click="$emit('update:value', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        </v-toolbar>
      <v-card-title :class="title" class="py-0">
        {{isExistingFeature ? 'Edit Feature' : 'Create Feature'}}
        <v-tooltip v-if="isExistingFeature" top>
          <template #activator="{ on }">
            <v-btn v-on="on" class="ml-3" icon :class="body" @click="showInfo = !showInfo">
              <v-icon>{{showInfo ? 'mdi-eye-off' : 'mdi-eye'}}</v-icon>
              <!-- {{showInfo ? 'Hide Info' : 'Show Info'}} -->
            </v-btn>
          </template>
          <span>{{showInfo ? 'Collapse Info' : 'Expand Info'}}</span>
        </v-tooltip>
        <v-spacer/>
        <small v-if="!showInfo">
          <strong>Page:</strong> {{feature.page.name}}
          <v-icon color="#000">mdi-circle-small</v-icon>
          <strong>Position:</strong> {{feature.position.name}}
          <v-icon color="#000">mdi-circle-small</v-icon>
          <strong>Count:</strong> {{feature.count}}
          <v-icon color="#000">mdi-circle-small</v-icon>
          <strong>Ad Retail:</strong> ${{formatCurrencyDisplay(feature.ad_retail)}}
        </small>
      </v-card-title>
      <v-form v-if="showInfo" ref="form" class="px-6 fill" flat>
        <v-row dense class="py-4">
          <v-col :cols="featPage">
            <v-autocomplete
              :loading="loadingPositions"
              :disabled="loadingPositions"
              :readonly="readonly"
              :rules="[v => !!v.id || 'Page Required']"
              :class="body"
              auto-select-first
              background-color="#fff"
              dense
              outlined
              placeholder="Select Page"
              label="Page"
              :items="pages"
              item-text="name"
              item-value="id"
              return-object
              v-model="localPage"
              autocomplete="off"
              hide-details="auto"
              :menu-props="{ bottom: true, offsetY: true, maxHeight: 220, rounded: '' }"
              @change='getPagePositions'>
              <template v-slot:item="data">
                  <template>
                    <v-list-item-content> 
                      <v-list-item-title>{{data.item.name}}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </template>
            </v-autocomplete>
          </v-col>
          <v-col :cols="featPos">
            <v-autocomplete
              :loading="loadingPositions"
              :disabled="loadingPositions"
              :readonly="readonly"
              :class="body"
              :rules="[v => !!v || 'Feature Position is required']"
              auto-select-first
              background-color="#fff"
              dense
              outlined
              placeholder="Select Feature Postition" label="Feature Position"
              :items.sync="pagePositions"
              item-text="name"
              item-value="id"
              return-object
              v-model="feature.position"
              autocomplete="off"
              hide-details="auto"
              :menu-props="{ bottom: true, offsetY: true, maxHeight: 220, rounded: '' }">
              <template v-slot:item="data">
                  <template>
                    <v-list-item-content> 
                      <v-list-item-title>{{data.item.name}}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </template>
            </v-autocomplete>
          </v-col>
          <v-col :cols="featText">
            <v-text-field
              :readonly="readonly"
              :class="body"
              dense
              background-color="#fff"
              outlined
              v-model="feature.feature_text"
              label="Feature Text"
              placeholder="Add Feature Text"
              autocomplete="off"
              :rules="!readonly ? featureTextRules : []"
              clearable
              hide-details="auto">
            </v-text-field>
          </v-col>
          <v-col v-if="$auth.tenant === 'alliance-retail-group'">
            <v-text-field
              :readonly="readonly"
              :class="body"
              dense
              background-color="#fff"
              outlined
              v-model="feature.deal_code"
              label="Deal Code"
              autocomplete="off"
              :rules="!readonly ? dealCodeRules : []"
              clearable
              hide-details="auto">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row dense align="center" class="pb-5">
          <v-col v-if="isExistingFeature || $auth.tenant === 'alliance-retail-group'" :cols="2">
            <v-text-field
              :readonly="readonly"
              :rules="!readonly ? [v => !!v || 'Count Required', validate_count] : []"
              :class="body"
              outlined
              dense
              type="number"
              background-color="input"
              label="Count"
              v-model="feature.count"
              prepend-inner-icon="mdi-pound"
              hide-details="auto">
            </v-text-field>
          </v-col>
          <v-icon v-if="isExistingFeature || $auth.tenant === 'alliance-retail-group'" dense >mdi-at</v-icon>
          <v-col v-if="isExistingFeature || $auth.tenant === 'alliance-retail-group'" :cols="2">
            <v-text-field
              :readonly="readonly"
              :rules="!readonly ? [v => !!v || 'Ad Retail Required', validate_ad_retail] : []"
              :class="body"
              outlined
              dense
              type="number"
              min="0.01"
              background-color="input"
              label="Ad Retail" 
              v-model="feature.ad_retail"
              prepend-inner-icon="mdi-currency-usd"
              hide-details="auto"
              >
            </v-text-field>
          </v-col>
          <v-col v-if="$auth.tenant !== 'pricechopper' && $auth.tenant !== 'alliance-retail-group'" :cols="isExistingFeature ? 2 : 3">
            <v-text-field
              :readonly="readonly"
              :class="body"
              outlined
              dense
              background-color="input"
              label="Sign Detail"
              v-model="feature.sign_detail"
              :rules="[validateText]"
              clearable
              hide-details="auto">
            </v-text-field>
          </v-col>
          <!-- <v-col :cols="isExistingFeature ? 2 : 4">
            <v-textarea :readonly="readonly" :class="body" outlined dense background-color="input" label="Family" v-model="feature.family" rows="1" no-resize clearable />
          </v-col> -->
          <v-col :cols="featNotes">
            <v-text-field
              :readonly="readonly"
              :class="body"
              outlined
              dense
              background-color="input"
              label="Feature Notes (Optional)"
              v-model="feature.notes"
              :rules="featureNotesRules"
              clearable
              hide-details="auto">
            </v-text-field>
          </v-col>
          <v-col align="right">
            <v-tooltip top v-if='showMoveCopy'>
              <template v-slot:activator="{ on }">
                <v-btn class="mr-4" v-if='showMoveCopy' v-on="on" :disabled="disableMoveCopy" fab small @click="toggleMoveCopyModal">
                  <v-icon>mdi-plus-box-multiple-outline</v-icon>
                </v-btn>
              </template>
              Move/Copy Feature
            </v-tooltip>
            <v-btn v-if='isExistingFeature && hasRequiredFields' color="primary" :loading="loading || childUpdating" :disabled="readonly || loading || childUpdating" @click="updateAdFeature">
              Save
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-divider v-if="isExistingFeature"/>
      <v-tabs v-if="isExistingFeature" background-color="white" hide-slider height="35" v-model="tab">
        <v-tab :ripple="false" class="text-capitalize" v-for="(component, index) in tabs" :key="index" :disabled='!component.show'>
          <span v-if="component.show">
            <v-icon>{{component.icon}}</v-icon>
            {{component.name}}
          </span>
        </v-tab>
        <v-tab-item v-for="component in tabs" :key="component.name">
          <component
            :is="component.content"
            :tab="tab"
            :showInfo="showInfo"
            :selectedAd="selectedAd"
            :feature="feature"
            :readonly="readonly"
            :adParty="adParty"
            @updating="handleChildUpdating">
            <template #footer-button>
              <v-card-actions>
                <v-spacer/>
                <v-btn :class="body" text @click="$emit('update:value', false)">
                  Close 
                </v-btn>
              </v-card-actions>
            </template>
          </component>
        </v-tab-item>
      </v-tabs>
      <v-card-actions v-if="!isExistingFeature">
          <v-spacer/>
          <v-btn :class="body" text @click="$emit('update:value', false)">
            Cancel
          </v-btn>
          <v-btn :disabled="!hasRequiredFields || readonly || loading || childUpdating" :loading="loading || childUpdating" 
          :class="body" class="green white--text" @click="isExistingFeature ? updateAdFeature() : createAdFeature()">
            Create
          </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog :value.sync="modal" persistent width="500">
      <v-card>
        <v-card-title class="font-weight-light">
          <v-icon class="red--text" large left>mdi-alert-octagon-outline</v-icon>
          Are you sure you want to close feature?
        </v-card-title>
        <v-card-text class="pa-6">
          <v-row justify="center">
          You have unsaved changes that will be lost.
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text :class="body" @click="modal = false">Cancel</v-btn>
          <v-btn :class="body" class="primary white--text ml-2" @click="$emit('update:value', false)">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <FeatureMoveCopy 
      v-if="moveCopyModal"
      :value.sync="moveCopyModal" 
      :selectedAd="selectedAd" 
      :selectedFeature="feature"
      :adParty="adParty"
      :pages="pages">
    </FeatureMoveCopy>
    <FeatureEditConfirm
      v-if="confirmEditDialog"
      :value.sync="confirmEditDialog" 
      :targetFeature="targetFeature"
      @confirmAction="confirmAction"
      @cancel="closeConfirmDialog">
    </FeatureEditConfirm>
  </v-dialog>
</template>
<script>
import { displayHelpers } from '@/mixins/display-helpers'
import { format } from '@/mixins/format'
import { tableConfig } from '@/mixins/table-config'
import { displayAlert } from '@/mixins/alert'
export default {
  name: 'FeatureView',
  components: {
    FeaturePromoItems: () => import('@/components/features/feature-promo-items'),
    FeatureNonPromoItems: () => import('@/components/features/feature-nonpromo-items'),
    FeatureItemSearch: () => import('@/components/features/feature-item-search'),
    PromotionList: () => import('@/components/features/promotion-list'),
    FeatureMoveCopy: () => import('@/components/features/feature-move-copy'),
    FeatureEditConfirm: () => import('@/components/features/feature-edit-confirm.vue')
  },
  mixins: [displayHelpers, format, tableConfig, displayAlert],
  props: [
    'currentPage',
    'getAdPageFeatures',
    'adFeatures',
    'selectedFeature',
    'selectedAd',
    'readonly',
    'value',
    'adParty',
    'pages'
  ],
  data: () => ({
    localPage : {},
    showInfo: true,
    pagePositions: [],
    menu: false,
    tab: 0,
    feature: {},
    modal: false,
    moveCopyModal: false,
    loading: false,
    childUpdating: false,
    confirmEditDialog: false,
    targetFeature: {},
    loadingPositions: false
  }),
  created() {
    if (this.$auth.tenant === 'alliance-retail-group' && !this.isExistingFeature) {
      this.feature.deal_code = 'ADVRD1'
    }
  },
  computed: {
    hasAdLayout() {
      return Boolean(this.selectedAd.layout_id)
    },
    breadcrumbs () {
      return [
        {
          text: this.selectedAd.ad_name,
          exact: true,
          disabled: false
        },
        {
          text: this.moment(this.selectedAd.ad_start_date).format('M/D/YYYY') + ' - ' + this.moment(this.selectedAd.ad_end_date).format('M/D/YYYY'),
          exact: true,
          disabled: true
        },
      ]
    },
    validFeature () {
      return !this._.isEmpty(this.feature.position) && !this._.isEmpty(this.feature.feature_text)
    },
    isExistingFeature () {
      return !this._.isEmpty(this.feature.id)
    },
    featureTextRules () {
      return this.$auth.tenant === 'pricechopper' ? [v => !!v || 'Feature Text Required'] : [v => !!v || 'Feature Text Required', this.validateText]
    },
    dealCodeRules () {
      return this.$auth.tenant === 'alliance-retail-group' ? [v => !!v || 'Deal Code Required'] : [v => !!v || 'Deal Code Required', this.validateText]
    },
    featureNotesRules () {
      return this.$auth.tenant === 'pricechopper' ? [] : [this.validateText]
    },
    showMoveCopy () {
      return this.$auth.tenant === 'alliance-retail-group' && this.isExistingFeature
    },
    disableMoveCopy () {
      return this.feature.non_promo_items.length === 0 && this.feature.promo_item_group_ids.length === 0
    },
    tabs () {
      if (!this.readonly) {
        return [
          { name: 'Promotional', content: 'FeaturePromoItems', icon: 'mdi-currency-usd', show: true },
          { name: 'Non-Promotional', content: 'FeatureNonPromoItems', icon: 'mdi-currency-usd-off', show: true },
          { name: 'Promotion List', content: 'PromotionList', icon: 'mdi-note-text', show: true},
          { name: this.$auth.tenant === 'alliance-retail-group' ? 'Non-Promo Item Search' : 'Item Search', content: 'FeatureItemSearch', icon: 'mdi-magnify', show: true }
        ]
      } else {
        return [
          { name: 'Promotional', content: 'FeaturePromoItems', icon: 'mdi-currency-usd', show: true },
          { name: 'Non-Promotional', content: 'FeatureNonPromoItems', icon: 'mdi-currency-usd-off', show: true },
        ]
      }
    },
    featPos () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xl': return this.isExistingFeature ? '2' : '3';
        case 'lg': return this.isExistingFeature ? '2' : '3';
        case 'md': return this.isExistingFeature ? '2' : '3';
        default: return '5em';
      }
    },
    featPage () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xl': return this.isExistingFeature ? '2' : '3';
        case 'lg': return this.isExistingFeature ? '2' : '3';
        case 'md': return this.isExistingFeature ? '2' : '3';
        default: return '5em';
      }
    },
    featText () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xl': return this.isExistingFeature ? '5' : '8';
        case 'lg': return this.isExistingFeature ? '5' : '8';
        case 'md': return this.isExistingFeature ? '5' : '8';
        default: return '5em';
      }
    },
    featNotes () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xl': return this.isExistingFeature ? '4' : '7';
        case 'lg': return this.isExistingFeature ? '4' : '7';
        case 'md': return this.isExistingFeature ? '3' : '7';
        default: return '5em';
      }
    },
    existingFeatures () {
      return this.adFeatures.reduce((acc, result) => {
        result = {
          id: result.position.id,
          feature_id: result.id
        }
        acc.push(result)
        return acc
      }, [])
    },
    hasRequiredFields() {
      return (
        this.feature.page?.name &&
        this.feature.position?.name &&
        this.feature.feature_text &&
        this.feature.feature_text.trim() !== ''
      );
    },
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) {
          this.localPage = this.currentPage
          this.getAdPages()
        }
      }
    },
    selectedFeature: {
      immediate: true,
      handler () {
        this.clearFeatureState()
        if (!this._.isEmpty(this.selectedFeature)) {
          this.feature = this._.cloneDeep(this.selectedFeature)
        } else {
          this.resetFeatureData()
        }
      }
    },
    localPage: {
      handler() {
        if (this.isExistingFeature){
          this.feature.page = this.localPage
          this.feature.position = null
          this.getPagePositions()
        } else{
          this.feature.page = this.localPage
        }
      }
    }
  },
  methods: {
    resetFeatureData() {
      this.feature = {
        ad_id: '',       
        feature_text: '',     
        promo_item_group_ids: [],
        notes: '',               
        non_promo_items: [],   
        page: this.localPage,  
        position: {},          
        count: 1,              
        ad_retail: 1.00,         
        family: '',             
        brand_combo: '',        
        sign_detail: ''          
      };
    },
    clearFeatureState() {
      this.items = []
      this.feature.promo_item_group_ids = []
    },
    getAdPages () {
      this.getPagePositions() 
      this.getAdPageFeatures(this.localPage)
    },
    async getPagePositions () {
      this.loadingPositions = true
      try {
        let positions = []
        if (this.selectedAd?.layout_id) {
          const params = { offset: 0, limit: 300 }
          let { data } = await this.$Features.getAdPageFeatures(this.selectedAd.id, this.localPage.id, params)
          if (data?.length > 0) {
            positions = data.map(f => {
              return {
                feature_id: f.id,
                feature_text: f.feature_text,
                page_id: f.page.id,
                ...f.position
              }
            }).toSorted((a, b) => a.display_order - b.display_order)
          }
        } else {
          let page = `PAGE_POSITION_${this.localPage.constant}`
          const params = { page: page, limit: 500 }
          const { data } = await this.$Features.getFeaturePositions(this.selectedAd.id, params)
          positions = data
          if (this.isExistingFeature) {
            positions.push(this.feature.position)
          }
        }
        this.pagePositions = positions
      } catch (e) {
        console.error(e)
        this.$store.dispatch('setSnackbar', { status: 'error', text: `Failed to Get Page Positions due to ${e?.response?.data?.message || e.message}` })
      } finally {
        this.loadingPositions = false
      }
    },
    async getFeature (featureId) {
      try {
        const { data } = await this.$Features.getAdFeatureById(featureId)
        this.feature = data
        this.feature.ad_retail = parseFloat(this.feature.ad_retail).toFixed(2)
      } catch (e) {
        console.error(e)
        this.$store.dispatch('setSnackbar', { status: 'error', text: `Failed to Get Feature due to ${e?.response?.data?.message || e.message}` })
      }
    },
    handleChildUpdating (isUpdating) {
      this.childUpdating = Boolean(isUpdating)
    },
    validate_count(count){
        let numbers_only = /^[0-9]+$/;
        count = count.toString()
        if(!count.match(numbers_only)){
          return false;
        }
        return true
    },
    validate_ad_retail(ad_retail){
      let numbers_and_decimal = /^\d{1,5}(\.\d{1,2})?$/;
      ad_retail = ad_retail.toString()
      if(!ad_retail.match(numbers_and_decimal)){
          return false;
        }
        return true
    },
    validateText (value) {
      const allowedChars = ['$', '/', '.', '-', ' ', `'`, `,`]
      if (value) {
        const chars = [...value]
        const invalidChars = chars.filter(c => {
          return (/[\W_]+/g.test(c)) && !allowedChars.includes(c)
        })
        return (invalidChars.length === 0) || `Invalid characters: ${[...new Set(invalidChars)].join(' ')}`
      }
      return true
    },
    async createAdFeature () {
      this.loading = true
      const valid = this.$refs.form.validate()
      if (!valid) {
        this.loading = false
        return
      }
      const newFeature = {
        ad_id: this.selectedAd.id,
        feature_text: this.feature.feature_text,
        promo_item_group_ids: [],
        notes: this.feature.notes,
        non_promo_items: [],
        page: this.feature.page,
        position: this.feature.position,
        count: 1,
        ad_retail: 1.00,
        family: this.feature.family,
        brand_combo: this.feature.family,
        sign_detail: this.feature.sign_detail
      }
      if (this.$auth.tenant === 'alliance-retail-group') {
        newFeature.count = this.feature.count
        newFeature.ad_retail = this.feature.ad_retail
        newFeature.deal_code = this.feature.deal_code
      }
      newFeature.ad_retail = parseFloat(newFeature.ad_retail).toFixed(2)
      try {
        const res = await this.$Features.createAdFeature(newFeature)
        if (res?.data?.id) {
          let featureId = res.data.id
          this.$emit('refresh')
          this.$store.dispatch('setSnackbar', { status: 'success', text: 'Feature Created' })
          this.getFeature(featureId)
          this.selectedFeature.id = featureId
        }
      } catch (err) {
        console.error(err)
        this.$store.dispatch('setSnackbar', {
          status: 'error',
          text: `Failed to Create Feature due to ${err?.response?.data?.message || err.message}`
        })
      } finally {
        this.loading = false
      }
    },
    async updateAdFeature (confirmEdit = true) {
      if (this.loading || this.childUpdating) {
        return
      }
      const valid = this.$refs.form.validate()
      if (!valid) {
        return
      }
      this.loading = true
      try {
        let emptyFeature = null
        let targetFeature = null
        if (this.$auth.tenant === 'alliance-retail-group' && this.selectedAd?.layout_id 
          && this.feature.position?.feature_id 
          && (this.feature.position.feature_id !== this.feature.id)
        ) {
          const { data } = await this.$Features.getAdFeatureById(this.feature.position.feature_id)
          if (data?.id) {
            targetFeature = data
            if (!this.isEmptyFeature(targetFeature)) {
              // try grabbing available position on Page 7
              emptyFeature = await this.getAvailableFeatureLocation()
              if (!emptyFeature) { // unlikely but still possible
                return this.$store.dispatch('setSnackbar', { status: 'error', text: "This feature can't be moved to an occupied location due to a lack of available positions on Page 7." })
              }
              if (confirmEdit) {
                this.targetFeature = targetFeature
                return this.confirmEditDialog = true
              }
              // prep to move the feature currently occupying the desired location to Page 7
              targetFeature.position = JSON.parse(JSON.stringify(emptyFeature.position))
              targetFeature.page = JSON.parse(JSON.stringify(emptyFeature.page))
              // prep to move the existing empty feature from Page 7 to this location
              emptyFeature.position = this.selectedFeature.position
              emptyFeature.page = this.selectedFeature.page
            } else {
              // if the desired feature location is already open, swap spots with this one
              targetFeature.position = this.selectedFeature.position
              targetFeature.page = this.selectedFeature.page
            }
          }
        }
        await this.$Features.updateAdFeature(this.feature.id, this.feature)
        if (targetFeature) {
          await this.$Features.updateAdFeature(targetFeature.id, targetFeature)
        }
        if (emptyFeature) {
          await this.$Features.updateAdFeature(emptyFeature.id, emptyFeature)
        }
        if (this.$auth.tenant !== 'alliance-retail-group' && this.selectedFeature) {
          this.selectedFeature.page = this._.cloneDeep(this.feature.page)
          this.selectedFeature.position = this._.cloneDeep(this.feature.position)
        }
        this.$store.dispatch('setSnackbar', { status: 'success', text: 'Feature Updated' })
        if (this.$auth.tenant === 'alliance-retail-group') {
          this.closeFeatureView()
        }
        this.$emit('refresh')
      } catch (err) {
        console.error(err)
        this.$store.dispatch('setSnackbar', { status: 'error', text: `Failed to Update Feature due to ${err?.response?.data?.message || err.message}` })
      } finally {
        this.loading = false
      }
    },
    async deleteAdFeature () {
      this.loading = true
      if (this.$auth.tenant === 'alliance-retail-group' && this.selectedAd.layout_id) {
        try {
          this.feature.count = 1
          this.feature.ad_retail = 1.00
          this.feature.promo_item_group_ids = []
          this.feature.deal_code = 'ADVRD1'
          this.feature.feature_text = ""
          this.feature.notes = ""

          await this.$Features.updateAdFeature(this.feature.id, this.feature, true)
          this.$store.dispatch('setSnackbar', { status: 'success', text: 'Feature Cleared' })
          this.closeFeatureView()
        } catch (err) {
          this.$store.dispatch('setSnackbar', { status: 'error', text: `Failed to Clear Feature due to ${err?.response?.data?.message || err.message}` })
        } finally {
          this.loading = false
        }
      } else {
        await this.$Features.deleteAdFeature(this.selectedFeature.id)
          .then(() => {
            this.$emit('update:value', false)
            this.$store.dispatch('setSnackbar', { status: 'success', text: `${this.feature.position.name} Deleted` })
            this.loading = false
          }).catch(err => {
            this.$store.dispatch('setSnackbar', { status: 'error', text: `Failed to Delete Feature due to ${err?.response?.data?.message || err.message}` })
          })
      }
    },
    toggleMoveCopyModal () {
      this.moveCopyModal = !this.moveCopyModal
    },
    closeFeatureView () {
      this.$emit('closeFeatureView')
    },
    async getAvailableFeatureLocation() {
      const page = this.pages.find(p => p?.constant === 'PAGE_7')
      try {
        const positionRes = await this.$Features.getEmptyPagePositions(this.selectedAd.id, page.id)
        if (positionRes?.data?.length > 0) {
          const nextFeature = positionRes.data.toSorted((a, b) => a.display_order - b.display_order)[0]
          if (nextFeature?.feature_id) {
            const { data } = await this.$Features.getAdFeatureById(nextFeature.feature_id)
            if (data?.id) return data
          }
        }
        return null
      } catch (err) {
        this.handleError(err)
      }
    },
    closeConfirmDialog() {
      this.confirmEditDialog = false
      this.targetFeature = {}
    },
    confirmAction() {
      this.closeConfirmDialog()
      this.updateAdFeature(false)
    },
    isEmptyFeature(feature) {
      return (feature?.promo_item_group_ids?.length === 0)
        && (feature?.non_promo_items?.length === 0)
         && (feature?.feature_text?.trim()?.length === 0)
    }
  }
}
</script>
<style scoped>
  .active {
    box-shadow: 0px 2px 10px 3px rgba(120,120,120,0.75);
    background: #385F73;
    color: white !important;
  }
</style>